import React, { useEffect } from 'react';

import InfoView from 'sharedComponents/InfoView';
import InfoViewSkeleton from 'sharedComponents/InfoViewSkeleton';

import { alphabetizeClients } from 'sharedHelpers/clientHelpers';

import useClientListHydration from 'sharedHooks/useClientListHydration';
import useFilterClients from 'sharedHooks/useFilterClients';
import useNavigateToClient from 'sharedHooks/useNavigateToClient';

import MessagesListPanelItem from './components/MessagesListPanelItem';
import MessagesInfoPanel from './components/MessagesInfoPanel';
import NewAnnouncementButton from './components/NewAnnouncementButton';

interface MessagesPageProps {
  clientId?: string;
}

function MessagesPage({ clientId }: MessagesPageProps): JSX.Element {
  const {
    clients,
    loading,
    isBackgroundLoadingClients,
  } = useClientListHydration();

  const filteredClientsList = useFilterClients({
    clientsList: clients,
    sortFunction: alphabetizeClients,
  });

  const navigateToClient = useNavigateToClient();

  useEffect(() => {
    if (!clientId && filteredClientsList.length) {
      navigateToClient(filteredClientsList[0].id);
    }
  }, [clientId, filteredClientsList.length, navigateToClient]);

  return (
    <>
      {loading && <InfoViewSkeleton />}
      {!loading && (
        <InfoView
          selectedItem={clientId}
          listPanelChildren={({ index, style }) => (
            <MessagesListPanelItem
              clientsData={filteredClientsList}
              style={style}
              index={index}
            />
          )}
          detailPanelChildren={
            clientId && <MessagesInfoPanel clientId={clientId} />
          }
          title="Messages"
          loadingMessage={
            isBackgroundLoadingClients ? 'Loading more clients…' : undefined
          }
          numberOfItems={filteredClientsList.length}
          HeaderButton={<NewAnnouncementButton />}
          errorMessage={
            clients.length > filteredClientsList.length
              ? 'There are no clients matching the current filters'
              : 'You have no clients to display'
          }
        />
      )}
    </>
  );
}

MessagesPage.defaultProps = {
  clientId: undefined,
};

export default MessagesPage;
